export default __webpack_public_path__ + "static/media/icon-linkedin.2237b71f.svg";